import AbstractCRMApi from '../../AbstractCRMApi';
import GetDepositDetailsResponse from '../Responses/DepositDetailsResponse';

class DepositsApi extends AbstractCRMApi {
    protected endpoint: string = 'deposit';

    async getDepositDetails(depositId: number): Promise<GetDepositDetailsResponse> {
        return (await this.get(`/${depositId}`)).data;
    }

    async isManualDepositEnabled(): Promise<boolean> {
        return !!(await this.get('/manual_deposit_enabled')).data.enabled;
    }
}

export default new DepositsApi();
